/**
 * Loads "similar frames" for the product page from Shopify's product
 * recommendations and puts the result in place.
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const fresh = html.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
          if (this.dataset.heading) {
            const heading = document.createElement('h3');
            heading.className = 'complementary__heading';
            heading.textContent = this.dataset.heading;
            this.prepend(heading);
          }
          document.dispatchEvent(new CustomEvent('yoroi:content-added'));
        }
      } catch (error) {
        /* Recommendations are optional; the page works without them. */
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
